import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getProducts } from "../services/api/productsApi";

export default function ProductSection() {
  const theme = useTheme();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- API CALL ---------------- */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getProducts();
        setProducts(res);
      } catch (err) {
        console.error("API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  /* ---------------- LOADING ---------------- */
  if (loading) {
    return (
      <Box textAlign="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, md: 3 } }}>

      {/* GRID */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          columnGap: { xs: 3, md: 4 },
          rowGap: { xs: 8, sm: 10, md: 10 },
        }}
      >
        {products.map((item, index) => (
          <Card
            key={item.id || index}
            sx={{
              borderRadius: 4,
              overflow: "visible",
              height: "100%",
              border: "2px solid #e4ecec",
              maxWidth: { xs: 350, sm: "100%" },
              mx: "auto",
              transition: "0.3s",
              boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
              },
            }}
          >

            {/* IMAGE */}
            <Box sx={{  p: 2, position: "relative" }}>
              <Box
                sx={{
                  // background: "#1f6f8b",
                  borderRadius: 4,
                  textAlign: "center",
                }}
              >
                <Box
                  component="img"
                  src={item.image || "/images/no-image.png"}
                  sx={{
                    borderRadius:4,
                    width: "100%",
                    height: "100%",
                    display: "block",
                    margin: "0 auto",
                    objectFit: "contain",
                  }}
                />
              </Box>

              {/* BADGE */}
              <Box
                component="img"
                src="/images/badge.png"
                sx={{
                  width: { xs: 100, md: 200 },
                  position: "absolute",
                  right: 5,
                  bottom: { xs: -38, md: -85 },
                }}
              />
            </Box>

            {/* CONTENT */}
            <Box sx={{ p: 3, pt: 5 }}>
              <Typography
                sx={{ fontSize: 13, color: "#2c7a7b", fontWeight: 600 }}
              >
                PRODUCT :
              </Typography>

              <Typography
                sx={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: "#146c70",
                  mb: 2,
                }}
              >
                {item.title}
              </Typography>

              {/* TABLE */}
              <Box
                sx={{
                  border: "1.5px solid #2c7a7b",
                  borderRadius: 2,
                  overflow: "hidden",
                  background: "#eaf4f7",
                }}
              >
                {[
                  ["NO. OF PIECES :", item.no_of_pieces],
                  ["SIZE :", item.size],
                  ["FRAGRANCE :", item.fragrance],
                  ["USE :", item.uses],
                  ["PACKING DETAIL :", item.packing_detail],
                ].map((row, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1.1fr 1fr",
                        sm: "1fr 1.2fr",
                        md: "1fr 1.4fr",
                      },
                    }}
                  >
                    {/* LEFT */}
                    <Box
                      sx={{
                        px: 2,
                        py: 1.2,
                        borderRight: "1.5px solid #2c7a7b",
                        borderBottom:
                          i !== 4 ? "1.5px solid #2c7a7b" : "none",
                      }}
                    >
                      <Typography fontSize={12.5} fontWeight={600}>
                        {row[0]}
                      </Typography>
                    </Box>

                    {/* RIGHT */}
                    <Box
                      sx={{
                        px: 2,
                        py: 1.2,
                        borderBottom:
                          i !== 4 ? "1.5px solid #2c7a7b" : "none",
                      }}
                    >
                      <Typography fontSize={12.5}>
                        {row[1] || "-"}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* BUTTON */}
            <Box mt="auto" p={2} display="flex" justifyContent="center">
              <Button
                sx={{
                  width: "70%",
                  borderRadius: 0,
                  textTransform: "none",
                  fontWeight: 600,
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                  border: `1px solid ${theme.palette.primary.main}`,
                  "&:hover": {
                    backgroundColor: "white",
                    color: "primary.main",
                  },
                }}
              >
                Discover more
              </Button>
            </Box>
          </Card>
        ))}
      </Box>
    </Container>
  );
}